import { computed } from 'vue';
import { useTheme } from 'vuetify';
import {
    PRICE_UI_THEME_KEY,
    type PriceUiThemeName,
} from '@/constants/uiTheme';

function persistUiTheme(name: PriceUiThemeName): void {
    try {
        localStorage.setItem(PRICE_UI_THEME_KEY, name);
    } catch {
        /* ignore */
    }
}

/**
 * Переключение светлой/тёмной темы Vuetify и запись в localStorage (`price-ui-theme`).
 */
export function useAppTheme() {
    const theme = useTheme();

    const isDark = computed(() => theme.global.current.value.dark);

    function setTheme(name: PriceUiThemeName): void {
        theme.change(name);
        persistUiTheme(name);
    }

    function toggleTheme(): void {
        setTheme(isDark.value ? 'light' : 'dark');
    }

    return {
        theme,
        isDark,
        setTheme,
        toggleTheme,
    };
}
